import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CommunitySignalService } from './community/community.signal.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignSaveCoordinatorService {
  private readonly router = inject(Router);
  private readonly communitySignalService = inject(CommunitySignalService);

  private triggerSaveSubject = new Subject<void>();
  private saveSuccessSubject = new Subject<void>();
  private saveErrorSubject = new Subject<string>();

  // Optional redirect URL to navigate to after save success
  private _redirectUrl: string | null = null;

  public triggerSave$ = this.triggerSaveSubject.asObservable();
  public saveSuccess$ = this.saveSuccessSubject.asObservable();
  public saveError$ = this.saveErrorSubject.asObservable();

  get redirectUrl(): string | null {
    return this._redirectUrl;
  }

  /**
   * Set redirect URL before triggering save
   */
  setRedirectUrl(url: string | null): void {
    this._redirectUrl = url;
  }

  /**
   * Clear redirect URL after navigation
   */
  clearRedirectUrl(): void {
    this._redirectUrl = null;
  }

  /**
   * Call this to trigger campaign save (createCampaign or updateCampaign based on isEditMode)
   */
  triggerCampaignSave(): void {
    this.triggerSaveSubject.next();
  }

  /**
   * Call this when campaign save succeeds, handles navigation automatically
   */
  emitSaveSuccess(): void {
    this.saveSuccessSubject.next();
    const redirectUrl = this._redirectUrl;
    this.clearRedirectUrl();
    if (redirectUrl) {
      this.router.navigateByUrl(redirectUrl);
    } else {
      const communityId = this.communitySignalService.getCommunity()?.id;
      if (communityId) {
        this.router.navigate([`/community/${communityId}/custom-form-builder`], { queryParams: { fromService: true } });
      }
    }
  }

  /**
   * Call this when campaign save fails
   */
  emitSaveError(errorMessage: string): void {
    this.saveErrorSubject.next(errorMessage);
  }
}
